module.exports = __webpack_public_path__ + "img/T5-D-rc_13.dc080182.png";